import Image from 'next/image';
import Link from 'next/link';

import { SocialItem } from '@/global/types/common.type';

export interface SocialProps extends SocialItem {
  className?: string;
}

const Social = ({ href, src, alt, className }: SocialProps) => {
  return (
    <Link href={href} target={'_blank'} style={{ lineHeight: 0 }}>
      <Image alt={alt} height={32} width={32} src={src} className={className} />
    </Link>
  );
};

export default Social;
